import styled from 'styled-components';
import { spacing } from '~/constants/spacing';

export const OurPillarsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.sm};

  @media (min-width: 750px) {
    > ul {
      display: grid;
      grid-template-columns: 25% 25% 25% 25%;
      gap: ${spacing.md};
      flex-wrap: wrap;
    }
  }

  @media (max-width: 750px) {
    > ul {
      display: flex;
      flex-direction: column;
      gap: ${spacing.sm};
    }
  }
`;

interface IButtonInfoProps {
  readonly color: string;
}
export const ButtonInfo = styled.li<IButtonInfoProps>`
  background-color: ${({ color }) => color};
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.25s;
  cursor: pointer;

  @media (max-width: 750px) {
    width: 100%;
  }

  &:hover {
    filter: brightness(1.25);
  }
`;
